export const SORT_METHODS = [
  { value: 'sort', label: 'Simple sort' },
  { value: 'linear', label: 'Linear' },
  { value: 'mix', label: 'Mix' },
];

export const MIX_DIRECTIONS = [
  { value: 'asc', label: 'Asc' },
  { value: 'desc', label: 'Desc' },
];

export const DIVERSITY_METHODS = [
  { value: 'fields', label: 'Fields' },
  { value: 'semantic', label: 'Semantic' },
];
